"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var rxjs_1 = require("rxjs");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var PreChatService = /** @class */ (function () {
    function PreChatService(http) {
        var _this = this;
        this.http = http;
        this.chatParams$ = new rxjs_1.BehaviorSubject([]);
        this.activeChatData$ = new rxjs_1.Subject();
        this.invitationAccepted$ = new rxjs_1.Subject();
        this.reactiveFormSubmit$ = new rxjs_1.Subject();
        window.addEventListener("message", function (event) {
            _this.receiveMessage(event);
        });
    }
    PreChatService.prototype.bindToMessageEvents = function () {
        return this.chatParams$.asObservable();
    };
    PreChatService.prototype.receiveMessage = function (event) {
        if (!event.data)
            return;
        switch (event.data.message) {
            case 'uwfSetChatParams':
                var params = event.data.params || [];
                this.chatParams$.next(params);
                break;
            case 'uwfInvitationAccepted':
                this.invitationAccepted$.next(event.data.invitationAccepted);
                break;
            case 'uwfActiveChatData':
                this.activeChatData$.next(event.data);
                break;
            case 'uwReactiveFormSubmit':
                this.reactiveFormSubmit$.next(event.data.submit);
                break;
            default:
                console.log('Unknown message received: ' + event.data.message);
        }
    };
    PreChatService.prototype.toggleChat = function () {
        parent.postMessage("uwfButtonClick", "*");
    };
    PreChatService.prototype.hideChat = function () {
        parent.postMessage("uwfHideChat", "*");
    };
    PreChatService.prototype.enableChat = function () {
        parent.postMessage('uwfEnableButton', '*');
    };
    PreChatService.prototype.getDefaultSkillAddress = function () {
        return this.http.get('/api/floatingchat/getdefaultskilladdress');
    };
    PreChatService.prototype.getSkillStatus = function (skillAddresses) {
        return this.http.post('/api/floatingchat/checkskillstatus', { skillAddress: skillAddresses });
    };
    PreChatService.prototype.getPreChatForm = function (lang, formTag) {
        return this.http.get("/api/ChatAdminSettings/GetPrechatForm/" + lang + "/" + formTag);
    };
    PreChatService.prototype.getDisplaySetting = function (id) {
        return this.http.get("/api/ChatAdminSettings/DisplaySetting/" + id);
    };
    PreChatService.prototype.getTimeZone = function () {
        return upstream.customerchat.helpers.GetTimeZoneName();
    };
    PreChatService.prototype.setFormSubmitted = function () {
        parent.postMessage('uwfSetFormSubmitted', '*');
    };
    PreChatService.prototype.updateChatState = function () {
        upstream.customerchat.helpers.updateShowChatState();
    };
    PreChatService.prototype.showPreChatFormForProactive = function () {
        parent.postMessage('uwfShowChatForActiveSession', '*');
    };
    PreChatService.prototype.sendChatFrameLoadEvent = function () {
        parent.postMessage("uwfChatFrameLoaded", "*");
    };
    PreChatService.prototype.logEvent = function (logEventCode, logEventDescription) {
        parent.postMessage({
            message: 'uwfLogEvent',
            eventCode: logEventCode,
            eventDescription: logEventDescription
        }, '*');
    };
    PreChatService.prototype.sendProactiveErrorMessage = function (errorMessage) {
        parent.postMessage({ message: 'uwfProactiveError', error: errorMessage }, "*");
    };
    PreChatService.ngInjectableDef = i0.defineInjectable({ factory: function PreChatService_Factory() { return new PreChatService(i0.inject(i1.HttpClient)); }, token: PreChatService, providedIn: "root" });
    return PreChatService;
}());
exports.PreChatService = PreChatService;
